import { vuex_subscribe_module, vuex_store_config } from '@/vuex';
import { load_state_from_local_storage } from '@/resources';

const vuex_config_object = {
  // gift card in vendita, montate dal catalogo (vedi build_products in
  // @livegift/resources). Le carica la home, unico I/O del flusso
  products: [],
  // prodotto a vista nel carousel, per productCode. Resta null finché il
  // catalogo non risolve: prima non c'è niente da poter scegliere
  selected_product: null,
  // taglio della gift card scelto nella home, in euro
  selected_amount: null,
  // ordine confermato al checkout (vedi build_order in @livegift/resources): lo
  // legge la sola pagina di conferma, resta null finché non si acquista e torna
  // null appena si lascia quella pagina (vedi il suo beforeDestroy)
  order: null,
};

export const serialized_vuex_config_object = JSON.stringify(vuex_config_object);

const state_config = vuex_store_config(vuex_config_object);

// il prodotto scelto per intero, non solo il suo productCode. Lo leggono le tre
// foglie che mostrano nome, loghi e testi della card mentre si compra (dettaglio
// della home, card blu, riepilogo del checkout): senza getter ognuna rifarebbe
// la stessa ricerca nell'elenco. La conferma non passa da qui, legge `order`
state_config.getters.selected_product_data = (state) => state.products
  .find((product) => product.id === state.selected_product) || {};

// azzera l'intento d'acquisto: catalogo e selezione. La chiama la conferma a
// ordine emesso, così dal back del browser il checkout non trova più un importo
// da comprare e rimbalza in home — senza, la stessa card si potrebbe acquistare
// due volte per sbaglio. `order` no: è quello che la conferma ha a video, e lo
// azzera lei stessa uscendo, così alle spalle di questo flusso non resta niente
state_config.mutations.reset_purchase = (state) => {
  state.products = [];
  state.selected_product = null;
  state.selected_amount = null;
};

// il nome del modulo coincide con VUE_APP_NAME: modal-notification.vue legge
// this.$store.state[process.env.VUE_APP_NAME]
const name = 'livegift';
const { state } = state_config;
const module = {
  namespaced: true,
  state: load_state_from_local_storage(name, state_config.state),
  mutations: {
    ...state_config.mutations,
  },
  getters: state_config.getters,
  actions: state_config.actions,
  get_local_storage_submodule() {
    // dichiaro le chiavi che verranno scritte nel local storage
    return {};
  },
};

export function register_state_module(prototype) {
  if (prototype.$submodules === undefined) prototype.$submodules = {};
  prototype.$submodules[name] = {
    get_local_storage_submodule: module.get_local_storage_submodule(),
  };
  vuex_subscribe_module(name, state, module);
}